var map = {
	"./de-AT.json": 58002,
	"./de-CH.json": 91447,
	"./de-DE.json": 32817,
	"./en-BE.json": 26136,
	"./en-CA.json": 65330,
	"./en-CH.json": 91766,
	"./en-GB.json": 29207,
	"./en-US.json": 46189,
	"./fr-BE.json": 21118,
	"./fr-CA.json": 76215,
	"./fr-CH.json": 32345,
	"./fr-FR.json": 6147,
	"./it-CH.json": 57130,
	"./it-IT.json": 7495,
	"./nl-BE.json": 60015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49484;